<template>
  <v-dialog v-model="dialog" max-width="500" scrollable>
    <v-card>
      <v-card-title class="justify-space-between">
        <div>{{ fullName }}'s connections</div>

        <div class="text-right">
          <v-btn fab text small @click="dialog = false" right
            ><v-icon>close</v-icon></v-btn
          >
        </div>
      </v-card-title>
      <!-- <v-card-subtitle>
                Total: {{noOfConnections}}
            </v-card-subtitle> -->
      <v-card-text>
        <v-list nav>
          <v-list-item
            v-for="connection in connections"
            :key="connection.connectionId"
          >
            <UserAvatar
              :key="connection.connectionId"
              :usersInitials="connection.firstName[0] + connection.lastName[0]"
              :displayImageUrl="connection.displayImageUrl"
            />
            <v-list-item-content>
              <v-list-item-title>{{
                getUsersFullName({
                  firstName: connection.firstName || "",
                  lastName: connection.lastName || "",
                })
              }}</v-list-item-title>
              <v-list-item-subtitle v-if="renderSubtitle(connection) != ''">{{
                renderSubtitle(connection)
              }}</v-list-item-subtitle>
              <!-- <v-list-item-content>{{connection.connectionId}}</v-list-item-content> -->
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

import Utility from "@/shared/utility";
import UserAvatar from "@/components/UserAvatar";
import {getQueryConnectionsCollection} from "@/shared/firebase_utils";
import {where} from "firebase/firestore";

export default {
  name: "ConnectionListDialog",
  components: {
    UserAvatar,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    fullName: {
      type: String,
      required: true,
    },
    businessCardId: {
      type: String,
      required: true,
    },
    noOfConnections: {
      type: String,
      required: true,
    },
  },
  created() {
    this.getUsersFullName = Utility.getUsersFullName;
  },
  watch: {
    value(newVal, oldVal) {
      this.dialog = newVal;
    },
    dialog(newVal, oldVal) {
      this.$emit("input", newVal);
      if (oldVal == false && newVal == true) {
        console.log("Load the first connection list page");
        this.getInitialPage();
      }
    },
  },
  data() {
    return {
      dialog: false,
      connections: [],
    };
  },
  methods: {
    renderSubtitle(connection) {
      if (connection.jobTitle != "" && connection.businessName != "")
        return `${connection.jobTitle} at ${connection.businessName}`;
      if (connection.businessName != "")
        return `from ${connection.businessName}`;
      else return "";
    },
    async getInitialPage() {
      this.connections = [];
      let querySnapshot = await getQueryConnectionsCollection(where("businessCardIds", "array-contains", this.businessCardId));
      querySnapshot.forEach((documentSanpshot) => {
        let connectionIndex = -1;
        const documentData = documentSanpshot.data();
        if (documentData.businessCardIds[0] == this.businessCardId)
          connectionIndex = 1;
        else if (documentData.businessCardIds[1] == this.businessCardId)
          connectionIndex = 0;
        this.connections.push({
          connectionId: documentSanpshot.id,
          firstName: documentData[`firstName${connectionIndex}`],
          lastName: documentData[`lastName${connectionIndex}`],
          displayImageUrl:
            documentData[`displayImageUrl${connectionIndex}`] == null
              ? ""
              : documentData[`displayImageUrl${connectionIndex}`],
          businessName:
            documentData[`businessName${connectionIndex}`] == null
              ? ""
              : documentData[`businessName${connectionIndex}`],
          jobTitle:
            documentData[`jobTitle${connectionIndex}`] == null
              ? ""
              : documentData[`jobTitle${connectionIndex}`],
        });
      });
    },
  },
};
</script>
